import React from 'react';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

/**
 * Generic collapsible expansion panel.
 *
 * Props:
 *   title      {string}   — header label
 *   open       {boolean}  — controlled open state
 *   onToggle   {fn}       — called on header click
 *   badge      {node}     — optional element rendered after the title (e.g. "(activa)")
 *   dot        {string}   — optional tailwind bg-* class for the status dot (omit to hide dot)
 *   children   {node}     — panel body
 *   className  {string}   — extra classes on the wrapper div
 */
const ExpansionPanel = ({ title, open, onToggle, badge, dot, children, className = '' }) => (
  <div className={`border border-line rounded-lg overflow-hidden ${className}`}>
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between pl-6 pr-1 py-3 bg-surface-2 hover:bg-surface transition-colors text-sm font-medium text-content"
    >
      <span className="flex items-center gap-2">
        {dot && (
          <span className={`inline-block w-2 h-2 rounded-full ${dot}`} />
        )}
        {title}
        {badge}
      </span>
      {open ? <CaretUp size={16} /> : <CaretDown size={16} />}
    </button>

    {open && (
      <div className="p-4 bg-surface">
        {children}
      </div>
    )}
  </div>
);

export default ExpansionPanel;
